import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { SvgIcon } from '@/components';
import { externalLinks } from '@/config';
import koloLogo from '@/assets/images/billing/kolo-logo.png';

import styles from './KoloPromo.module.sass';

const KOLO_CASHBACK_PERCENT = 2;

interface KoloPromoProps {
  amount: number;
  className?: string;
}

export const KoloPromo = ({ amount, className }: KoloPromoProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  const cashback = ((amount * KOLO_CASHBACK_PERCENT) / 100).toFixed(2);

  return (
    <div className={cx(styles.promo, isOpen && styles.promoOpen, className)}>
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={koloLogo} alt="" className={styles.logo} />
        <span className={styles.title}>
          {t('translation.kolo_promo_title', {
            percent: KOLO_CASHBACK_PERCENT,
          })}
        </span>
      </button>

      <div
        id={contentId}
        className={cx(styles.collapse, isOpen && styles.open)}
        aria-hidden={!isOpen}
      >
        <div className={styles.content}>
          <p className={styles.text}>
            {t('translation.kolo_promo_text', {
              percent: KOLO_CASHBACK_PERCENT,
              amount: cashback,
            })}
          </p>
          <a
            href={externalLinks.KOLO_PROMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {t('translation.kolo_promo_link')}
            <SvgIcon name="arrow-up-right" className={styles.linkIcon} />
          </a>
        </div>
      </div>
    </div>
  );
};
